import { render } from "./ArchiveAdd.vue?vue&type=template&id=64e4d7a6&scoped=true"
import script from "./ArchiveAdd.vue?vue&type=script&lang=js"
export * from "./ArchiveAdd.vue?vue&type=script&lang=js"

import "./ArchiveAdd.vue?vue&type=style&index=0&id=64e4d7a6&lang=scss&scoped=true"

import exportComponent from "E:\\uni-app项目\\kxsns-master\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64e4d7a6"]])

export default __exports__